import React from 'react'

const ReturnPolicy = () => {
  return (
    <div>
      
    </div>
  )
}

export default ReturnPolicy
